import { z } from 'zod';
import { UnionOfKeys } from '@anytag/shared-types';
import { getFirstDay } from '@anytag/shared-utils';
import { SearchSchema } from '@anytag/shared-validations';

export const YoutubeCMSInvoicesSearchSchema = SearchSchema.create({
  filter: {
    schema: z.object({ month: SearchSchema.types.string(), keyword: SearchSchema.types.string() }),
    defaultValues: { month: getFirstDay() }
  }
});

export type YoutubeCMSInvoicesSearchSchemaType = z.infer<typeof YoutubeCMSInvoicesSearchSchema>;
export type YoutubeCMSInvoicesFilterFormValues = YoutubeCMSInvoicesSearchSchemaType['filter'];
export type YoutubeCMSInvoicesFilterFormKeys = UnionOfKeys<YoutubeCMSInvoicesFilterFormValues>;
